import React, { useState, useEffect, useContext } from 'react';
import { VideoPlayerModal as NyyVideoPlayerModal, pitchResult, mapPlaylistFromVideoSearch, LoadingSpinner } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import { useOktaAuth } from '@okta/okta-react';
import styled from 'styled-components';
import { Video, useOktaQuery } from '../../../../data';
import { store } from '../../../../store';

const PageCoverDiv = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const VideoPlayerModal = ({ container, playlistPitches }) => {
    const { state: { user } } = useContext(store);
    const { t: translate } = useTranslation();
    const { authState: { accessToken } } = useOktaAuth();

    const [multiVideoParams, setMultiVideoParams] = useState('');
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const [showVideoPlayerModal, setShowVideoPlayerModal] = useState(false);

    const { isFetching: videosLoading, data: videoData } = useOktaQuery(
        ['multivideo', multiVideoParams],
        (t) => Video.multi(t, multiVideoParams),
        { enabled: !!multiVideoParams.length },
    );

    useEffect(() => {
        if (playlistPitches.length) {
            setShowVideoPlayerModal(true);
            setMultiVideoParams(JSON.stringify(playlistPitches.map((x) => ({ g: x.gameid, e: x.eventseq, p: x.pitchseq }))));
        }
    }, [playlistPitches]);
    useEffect(() => {
        if (showVideoPlayerModal && videoData != null && videoData.videos != null && videoData.videos.length > 0) {
            videoData.videos.forEach((x) => { x.result = pitchResult(x.result, false, translate); });
            setVideoPlaylist(mapPlaylistFromVideoSearch({ videos: videoData.videos, playervideos: [] }, user.Roles.map((r) => r.RoleName)));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoData, showVideoPlayerModal]);

    const onHideVideoPlayerModal = () => {
        setVideoPlaylist(null);
        setShowVideoPlayerModal(false);
    };

    const loadPitchData = async ({ gameid, eventseq, pitchseq }) => {
        const resp = await Video.data(accessToken, { gameid, eventseq, pitchseq });
        return (resp && resp.length) ? resp[0] : null;
    };

    return (
        <>
            <NyyVideoPlayerModal
                playlist={videoPlaylist}
                show={!!videoPlaylist}
                onHide={onHideVideoPlayerModal}
                container={container}
                loadPitchData={loadPitchData}
                hideDownload
                hideShare
                hideFrameGrab
            />
            {videosLoading && (
                <PageCoverDiv>
                    <div>
                        <LoadingSpinner /><br />
                        <div className="fs-5 mt-2">{translate('sections.opponent.player.loading-videos')}</div>
                    </div>
                </PageCoverDiv>
            )}
        </>
    );
};

export default VideoPlayerModal;
